<script>
    import Carousel from '../Carousel.svelte';
    import ProductGrid from '$lib/components/ProductGrid.svelte';
    import ProductList from '$lib/components/ProductList.svelte';
    import { getContext } from 'svelte';

    export let content = {};
    export let modulePosition;
    export let sectionPosition;

    const products = content?.items?.[0]?.products || [];

    // Settings from cms
    let limit = content?.limit;
    let cardLayout = content?.layout;
    let style = content?.style;
    let alignment = content?.alignment;
    let showOutOfStock = content?.showOutOfStock;
    let showProductPrice = content?.showProductPrice;
    let containerLayout = content?.display;
    let gridCardsAcross = content?.cardsAcross;
    const pathname = getContext('pathname')();

    // filter products array to only those availableForSale and no discontinued (Archived)
    let availableProducts = products.filter((product) => {
        if (product?.linkedStore?.[0]?.status === 'ARCHIVED') return;
        if (pathname.includes('collection')) return product;
        if (product?.linkedStore?.[0]?.availableForSale) return product;
        return;
    });

    // if not enough products to fill a 5 grid show all products, slice to limit and hide OOS styles
    if (availableProducts.length < 5) {
        availableProducts = products.slice(0, limit || 50); // Catch with a default
    }

    // if limit set in cms then slice array to set limit
    if (limit) {
        availableProducts = availableProducts.slice(0, limit);
    }

    // set info alignment
    let alignInfo = '';
    switch (alignment) {
        case 'Left':
            alignInfo = 'text-left';
            break;
        case 'Center':
            alignInfo = 'text-center';
            break;
        case 'Right':
            alignInfo = 'text-right';
            break;
        default:
            alignInfo = '';
            break;
    }

    // set amount of cards across lg:online
    let cardsAcross = '';
    switch (gridCardsAcross) {
        case '3':
            cardsAcross = 'grid-cols-2 lg:grid-cols-3';
            break;
        case '4':
            cardsAcross = 'grid-cols-2 lg:grid-cols-4';
            break;
        case '5':
            cardsAcross = 'grid-cols-2 lg:grid-cols-5';
            break;
        default:
            cardsAcross = 'grid-cols-2 lg:grid-cols-5';
            break;
    }
</script>

{#if containerLayout === 'Carousel'}
    <Carousel key={sectionPosition} showButtons={availableProducts.length > 5}>
        {#each availableProducts as product (product)}
            {#if cardLayout === 'Grid'}
                <div class="w-[193px] flex-none lg:w-[19.5%]">
                    <ProductGrid
                        product={product?.linkedStore[0]}
                        {showOutOfStock}
                        {showProductPrice}
                        {alignInfo}
                        {style}
                        lazyLoadImage={sectionPosition >= 4}
                    />
                </div>
            {:else}
                <div class="w-[95%] flex-none lg:w-[49.6%]">
                    <ProductList product={product?.linkedStore[0]} {showOutOfStock} {showProductPrice} {style} lazyLoadImage={sectionPosition >= 4} />
                </div>
            {/if}
        {/each}
    </Carousel>
{:else}
    <div class={`grid gap-2 overflow-visible lg:gap-4 ${cardLayout === 'Grid' ? cardsAcross : 'lg:grid-cols-2'}`} data-moduleposition={modulePosition}>
        {#each availableProducts as product (product)}
            {#if cardLayout === 'Grid'}
                <ProductGrid product={product?.linkedStore[0]} {showOutOfStock} {showProductPrice} {alignInfo} {style} lazyLoadImage={sectionPosition >= 4} />
            {:else}
                <ProductList product={product?.linkedStore[0]} {showOutOfStock} {showProductPrice} {style} lazyLoadImage={sectionPosition >= 4} />
            {/if}
        {/each}
    </div>
{/if}
